// extracted by mini-css-extract-plugin
export const artist_item = "ArtistItem-module--artist_item--1XOvh";
export const artist_item__avatar = "ArtistItem-module--artist_item__avatar--3CE3S";
export const artist_item__name = "ArtistItem-module--artist_item__name--19cy7";
export const artist_item__social_section = "ArtistItem-module--artist_item__social_section--2kTg_";
export const artist_item__social = "ArtistItem-module--artist_item__social--3wJkX";
export const artist_item__footer = "ArtistItem-module--artist_item__footer--OE0x2";
export const artist_item__view_songs = "ArtistItem-module--artist_item__view_songs--1t7hG";